import { ChangeDetectionStrategy, Component, effect, input, output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { SupportedLanguage } from '@navstation-portal/shared/data-model/translation';
import { SelectButton } from 'primeng/selectbutton';

@Component({
  selector: 'nsp-language-selector',
  templateUrl: './language-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, SelectButton],
})
export class LanguageSelectorComponent {
  readonly currentLanguage = input.required<SupportedLanguage>();
  readonly languages = Object.values(SupportedLanguage);

  languageChange = output<SupportedLanguage>();

  readonly formControl = new FormControl(SupportedLanguage.English, { nonNullable: true });

  constructor() {
    effect(() => {
      this.formControl.setValue(this.currentLanguage());
    });
  }

  onLanguageClick = (language: SupportedLanguage) => this.languageChange.emit(language);
}
